import { gql } from '@apollo/client';
import type { Report2PerceptionBenchmarkSectionFragment } from '../../../../../generated/types';

import { dummySectionPerceptionBenchmarkingId } from '../../../constants';
import { useReportDynamicData } from '../../../hooks';
import {
  LockedBenchmarking,
  SectionDescription,
  SectionGroup,
  SectionHeader,
  SectionHeaderGrid,
  SectionInsights,
} from '../../common';
import PerceptionBenchmarkSentimentOverview from './PerceptionBenchmarkSentimentOverview';

export const REPORT2_PERCEPTION_BENCHMARK_SECTION_FRAGMENT = gql`
  fragment Report2PerceptionBenchmarkSection on ReportPerceptionBenchmarkSection {
    id
    title
    state
    subSections {
      ...Report2PerceptionBenchmarkSentimentOverview
      ...Report2SectionInsights
    }
  }
`;

export const PerceptionBenchmarkSection = ({
  section,
}: {
  section: Report2PerceptionBenchmarkSectionFragment;
}) => {
  const isDummyUpsell = section.id === dummySectionPerceptionBenchmarkingId;
  return isDummyUpsell ? (
    <LockedBenchmarking>
      <Inner section={section} />
    </LockedBenchmarking>
  ) : (
    <Inner section={section} />
  );
};

const Inner = ({ section }: { section: Report2PerceptionBenchmarkSectionFragment }) => {
  const { brandColor } = useReportDynamicData();
  return (
    <SectionGroup id={section.id}>
      <SectionHeaderGrid>
        <SectionHeader
          as="h2"
          variant="reportDisplayLarge"
          mobileVariant="reportDisplaySmall"
          section={section}
          color={brandColor}
        />
        <SectionDescription
          as="p"
          variant="reportLabelMedium"
          textAlign="right"
          section={section}
        />
      </SectionHeaderGrid>

      {section.subSections.map(subSection => {
        switch (subSection.__typename) {
          case 'ReportPerceptionBenchmarkSentimentOverview':
            return (
              <PerceptionBenchmarkSentimentOverview key={subSection.id} section={subSection} />
            );
          case 'ReportSectionInsights':
            return <SectionInsights key={subSection.id} section={subSection} />;
          default:
            return null;
        }
      })}
    </SectionGroup>
  );
};
